// DOM Ready
function documentReady(fn) {
    if (document.readyState !== 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}

// Countdown Timer
const countdownTimer = {
    showTimer: function () {
        const offHours = document.querySelectorAll('.nav-user-shipping.off-hours');
        const offHoursMobile = document.querySelectorAll('.nav-user-shipping-mobile.off-hours');
        const onHours = document.querySelectorAll('.nav-user-shipping.on-hours');
        const onHoursMobile = document.querySelectorAll('.nav-user-shipping-mobile.on-hours');
        offHours.forEach(element => {
            element.style.display = 'none';
        });
        offHoursMobile.forEach(element => {
            element.style.display = 'none';
        });
        onHours.forEach(element => {
            element.style.display = 'flex';
        });
        onHoursMobile.forEach(element => {
            element.style.display = 'flex';
        });
    },
    hideTimer: function () {
        const offHours = document.querySelectorAll('.nav-user-shipping.off-hours');
        const offHoursMobile = document.querySelectorAll('.nav-user-shipping-mobile.off-hours');
        const onHours = document.querySelectorAll('.nav-user-shipping.on-hours');
        const onHoursMobile = document.querySelectorAll('.nav-user-shipping-mobile.on-hours');
        onHours.forEach(element => {
            element.style.display = 'none';
        });
        onHoursMobile.forEach(element => {
            element.style.display = 'none';
        });
        offHours.forEach(element => {
            element.style.display = 'flex';
        });
        offHoursMobile.forEach(element => {
            element.style.display = 'flex';
        });
    },
    isHoliday: function () {
        const timeZone = 'America/New_York';
        const now = new Date().toLocaleString('en-US', {timeZone});

        
        
        

        

        // List of dates to check against
        const datesToCheck = [
            '12/24/2023','12/25/2023','12/31/2023','01/01/2024','01/15/2024','05/27/2024','07/03/2024','07/04/2024','09/02/2024','11/27/2024','11/28/2024','11/29/2024','12/24/2024','12/25/2024'
        ];

        // Convert today's date to the format MM/DD/YYYY
        const formattedDate = new Date(now).toLocaleDateString('en-US', {
            timeZone,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        });

        // Check if today's date is in the list
        return datesToCheck.includes(formattedDate);
    },
    isWeekDay: function () {
        const currentDate = new Date();
        const currentDay = currentDate.getDay(); // 0 (Sunday) to 6 (Saturday)

        // Check the Holiday schedule first
        if (countdownTimer.isHoliday()) {
            return false;
        }

        // Check if the current day is Monday (1) through Thursday (4)
        return currentDay >= 1 && currentDay <= 4;
    },
    isBetween9AM3PM_EST: function () {
        const timeZone = 'America/New_York';
        const now = new Date();
        const currentSecond = now.getSeconds();
        const options = {timeZoneName: 'short'};

        const currentTime = new Date().toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
            timeZone
        });
        const currentHour = currentTime.split(':')[0];
        const currentMinute = currentTime.split(':')[1];

        // Check if the current time is between 9:00 AM and 3:00 PM in EST
        const startHour = parseInt(9);
        const endHour = parseInt(15);

        if (currentHour >= startHour && currentHour < endHour) {
            // Calculate remaining time until 3:00 PM
            const remainingHours = 14 - currentHour;
            const remainingMinutes = 60 - currentMinute;
            const remainingSeconds = 59 - currentSecond;
            const remainingTime = `${remainingHours}:${remainingMinutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
            return `${remainingTime}`;
        } else {
            return false;
        }
    },
    updateTime: function (remainingTime) {
        if (!remainingTime) {
            countdownTimer.hideTimer();
            window.clearInterval(window.timerInterval);
            return;
        }
        const countdownTimerEl = document.querySelectorAll('.shipping-notice .countdown-timer');
        countdownTimerEl.forEach(element => {
            element.innerHTML = remainingTime;
        })
    },
    triggerTimer: function () {
        // If it is Monday through Thursday
        if (countdownTimer.isWeekDay()) {
            const remainingTime = countdownTimer.isBetween9AM3PM_EST();

            // If this is between 9:00 AM and 3:00 PM EST
            if (remainingTime !== false) {
                countdownTimer.updateTime(countdownTimer.isBetween9AM3PM_EST());
                window.timerInterval = setInterval(() => countdownTimer.updateTime(countdownTimer.isBetween9AM3PM_EST()), 1000);
                countdownTimer.showTimer();
            }
            // Not between 9:00 AM and 3:00 PM EST
            else {
                countdownTimer.hideTimer();
            }
        }
        // Not Monday through Thursday
        else {
            countdownTimer.hideTimer();
        }

    }
}

// Subscription Page: Variant Selector Switch for ATC
const subscriptionVariant = () => {
    const subscriptionSelect = document.querySelectorAll('.subscription-select');

    subscriptionSelect.forEach(select => {
        select.addEventListener('change', function () {
            const selected = this.options[this.selectedIndex];
            const price = selected.dataset.price;
            select.parentNode.querySelector('.product-variant-id').value = selected.value;
            select.parentNode.parentNode.querySelector('.product-grid-price div').innerHTML = '$' + parseInt(price / 100).toFixed(2);
        });

    });
}

function updateDisplayPrice(productId, price) {
    const priceElements = document.querySelectorAll(`.display-price[data-product-id="${productId}"]`);

    priceElements.forEach(el => {
        el.innerHTML = '$' + price;
    });
}


// Variant Selector Switch for ATC
const variantPriceSwitch = () => {
    const productGridSelect = document.querySelectorAll('.product-grid-select');

    productGridSelect.forEach(select => {
        select.addEventListener('change', function () {

            const selected = this.options[this.selectedIndex];
            const price = selected.dataset.price;
            const productId = select.dataset.productid;
            const cardPrices = document.querySelectorAll(`.display-price[data-product-id="${productId}"]`);


            select.parentNode.querySelector('.product-variant-id').value = selected.value;
            if (select.parentNode.parentNode.parentNode.querySelector('.product-grid-price .comparing-prices .regular-price')) {
                select.parentNode.parentNode.parentNode.querySelector('.product-grid-price .comparing-prices .regular-price').innerHTML = '$' + price;
            }
            if (select.parentNode.parentNode.parentNode.querySelector('.product-grid-price .regular-price')) {
                select.parentNode.parentNode.parentNode.querySelector('.product-grid-price .regular-price').innerHTML = '$' + price;
            }
            if (select.parentNode.parentNode.parentNode.querySelector('.collection-price .display-price')) {
                select.parentNode.parentNode.parentNode.querySelector('.collection-price .display-price').innerHTML = '$' + price;
            }

            cardPrices.forEach(el => {
                el.innerHTML = '$' + price;
            });

            if (parseInt(selected.dataset.index) === 3) {
                if (select.parentNode.parentNode.parentNode.querySelector('.product-grid-price .comparing-prices .compare-at')) {
                    select.parentNode.parentNode.parentNode.querySelector('.product-grid-price .comparing-prices .compare-at').classList.remove('d-none');
                }
                if (select.parentNode.parentNode.parentNode.querySelector('.product-grid-price-container[data-product-id="' + productId + '"] s.regular-price[data-variant-index="' + selected.dataset.index + '"]')) {
                    document.querySelectorAll('.product-grid-price-container[data-product-id="' + productId + '"] s.regular-price').forEach((element) => {
                        element.classList.add('d-none');
                    });
                    select.parentNode.parentNode.parentNode.querySelector('.product-grid-price-container[data-product-id="' + productId + '"] s.regular-price[data-variant-index="' + selected.dataset.index + '"]').classList.remove('d-none');
                    if(select.parentNode.parentNode.parentNode.querySelector('.product-grid-price-container[data-product-id="' + productId + '"] .grid-sale-prices')){
                        select.parentNode.parentNode.parentNode.querySelector('.product-grid-price-container[data-product-id="' + productId + '"] .grid-sale-prices').innerHTML = '$' + price;
                    }
                }
                if (document.querySelector('.product-grid-price[data-product-id="' + productId + '"] .comparing-prices .compare-at')) {
                    document.querySelector('.product-grid-price[data-product-id="' + productId + '"] .comparing-prices .compare-at').classList.remove('d-none');
                }
                if (document.querySelector('.product-grid-price-container[data-product-id="' + productId + '"] .compare-at')) {
                    document.querySelector('.product-grid-price-container[data-product-id="' + productId + '"] .compare-at').classList.remove('d-none');
                }
            }
            else {
                if (select.parentNode.parentNode.parentNode.querySelector('.product-grid-price .comparing-prices .compare-at')) {
                    select.parentNode.parentNode.parentNode.querySelector('.product-grid-price .comparing-prices .compare-at').classList.add('d-none');
                }
                if (select.parentNode.parentNode.parentNode.querySelector('.product-grid-price-container[data-product-id="' + productId + '"] s.regular-price')) {
                    document.querySelectorAll('.product-grid-price-container[data-product-id="' + productId + '"] s.regular-price').forEach((element) => {
                        element.classList.add('d-none');
                    });
                    if(select.parentNode.parentNode.parentNode.querySelector('.product-grid-price-container[data-product-id="' + productId + '"] .grid-sale-prices')){
                        select.parentNode.parentNode.parentNode.querySelector('.product-grid-price-container[data-product-id="' + productId + '"] .grid-sale-prices').innerHTML = '$' + price;
                    }
                    select.parentNode.parentNode.parentNode.querySelector('.product-grid-price-container[data-product-id="' + productId + '"] s.regular-price').classList.add('d-none');
                }
                if (select.parentNode.parentNode.parentNode.querySelector('.product-grid-price-container[data-product-id="' + productId + '"] s.regular-price[data-variant-index="' + selected.dataset.index + '"]')) {
                    document.querySelectorAll('.product-grid-price-container[data-product-id="' + productId + '"] s.regular-price').forEach((element) => {
                        element.classList.add('d-none');
                    });
                    select.parentNode.parentNode.parentNode.querySelector('.product-grid-price-container[data-product-id="' + productId + '"] s.regular-price[data-variant-index="' + selected.dataset.index + '"]').classList.remove('d-none');
                }
            }

        });

    });
}

// Mega Menu Variant Selector and Add to Cart
const megaMenuVariant = () => {
    const productSelect = document.querySelector('.mega-menu-inner #productSelect');
    const productVariantIdContainer = document.querySelector('.mega-menu-inner .product-variant-id');

    if (!productSelect || !productVariantIdContainer) {
        return;
    }

    productSelect.addEventListener('change', function () {
        productVariantIdContainer.value = productSelect.value;
    });
}

// Collection Page: Variant Select Price Change
const collectionPageVariants = () => {
    const productSelect = document.querySelectorAll('.component-collection #productSelect');

    productSelect.forEach(select => {
        const productPriceContainerSale = select.parentNode.parentNode.querySelector('.grid-sale-prices');
        const productPriceContainer = select.parentNode.parentNode.querySelector('.product-grid-price');

        if (productPriceContainerSale) {
            select.addEventListener('change', function () {
                productPriceContainerSale.innerHTML = '$' + select.options[select.selectedIndex].dataset.price;
            });
        }
        if (productPriceContainer) {
            select.addEventListener('change', function () {
                productPriceContainer.innerHTML = '$' + select.options[select.selectedIndex].dataset.price;
            });
        }
    });
}

// Cart Page: Quantity Increment
const cartPageQuantityIncrements = () => {
    const plusButtons = document.querySelectorAll('.cart-product-bottom .plus');
    const minusButtons = document.querySelectorAll('.cart-product-bottom .minus');

    // Add a click event listener to each '.plus' element
    plusButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            // Find the parent element containing '.quantity-selector'
            const quantitySelector = button.parentNode.querySelector('.quantity-selector');

            // Get the current value and increment it by 1
            const currentValue = parseInt(quantitySelector.value, 10);
            if (!isNaN(currentValue)) {
                quantitySelector.value = currentValue + 1;
            }
        });
    });

    // Add a click event listener to each '.minus' element
    minusButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            // Find the parent element containing '.quantity-selector'
            const quantitySelector = button.parentNode.querySelector('.quantity-selector');

            // Get the current value and decrement it by 1 if it's greater than 0
            const currentValue = parseInt(quantitySelector.value, 10);
            if (!isNaN(currentValue) && currentValue > 1) {
                quantitySelector.value = currentValue - 1;
            }
        });
    });

}

// Toggle Search Bar
const toggleSearchBar = () => {
    $(document).on('click', '.js-show-search-now', function () {
        const navElement = document.querySelector('nav.nav');
        const searchBarElement = document.querySelector('.search-bar');
        navElement.classList.toggle('closed');
        searchBarElement.classList.toggle('closed');
    });
}

// Account - Yotpo My Rewards
const yotpoMyRewards = () => {
    const yotpoWidget = document.querySelector('.yotpo-widget-my-rewards-widget');
    const descriptionBox = document.querySelector('.yotpo-widget-my-rewards-widget .yotpo-description');
    const redeemText = 'Proceed to checkout to redeem your points.';
    const redeemLine = `<div class="yotpo-redeem-checkout body1">${redeemText}</div>`;

    if (yotpoWidget && descriptionBox) {
        descriptionBox.insertAdjacentHTML('beforeend', redeemLine);
    }
}

countdownTimer.triggerTimer();

documentReady(function () {
    subscriptionVariant();
    megaMenuVariant();
    cartPageQuantityIncrements();
    toggleSearchBar();
    variantPriceSwitch();
    setTimeout(function () {
        yotpoMyRewards();
    }, 2300);
});


// Hamburger Animation
$(".hamburger").click(function () {
    $(this).toggleClass("is-active");
});

$(".js-nav-control").click(function () {
    $('body').toggleClass('open');
});


// Smooth Scroll Animation


// SEARCH
$('.user-icons').on("click", function (e) {
    $('#search-pop').hide();
});


/*
$("body").on("click", '.js-show-search, .search-close', function (e) {
    $('.search-close').css('padding-top', $('.header').height() + 100 + 'px')
    if ($('#search-pop').is(":visible") && $(window).scrollTop() == 0) {
        $(".index .header").removeClass('header_bar');
        $('.index .header .logo img').attr('src', $('.logo img').data('src-home'));
    } else {
        $(".index .header").addClass('header_bar');
        $('.index .header .logo img').attr('src', $('.logo img').data('src'));
    }

    $('#search-pop').fadeToggle('fast').find('input').focus();
    e.stopPropagation();
    e.preventDefault();
});

 */

// Collection Carousel
$(document).ready(function () {
    var collectionCarousel = $(".collection-carousel");
    collectionCarousel.each(function () {
        var $carousel = $(this);
        var isFullSlideMobile = $carousel.closest('.carousel-full-slide-mobile').length > 0;
        
        // Base responsive config
        var responsiveConfig = [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    arrows: true,
                }
            }
        ];
        
        // Add mobile breakpoints based on full slide setting
        if (isFullSlideMobile) {
            responsiveConfig.push({
                breakpoint: 600,
                settings: {
                    centerMode: false,
                    centerPadding: '0px',
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: true,
                }
            });
            responsiveConfig.push({
                breakpoint: 480,
                settings: {
                    centerMode: false,
                    centerPadding: '0px',
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: false,
                }
            });
        } else {
            responsiveConfig.push({
                breakpoint: 600,
                settings: {
                    centerMode: true,
                    centerPadding: '60px',
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: true,
                }
            });
            responsiveConfig.push({
                breakpoint: 480,
                settings: {
                    centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: false,
                }
            });
        }
        
        $carousel.slick({
            slidesToShow: 4,
            slidesToScroll: 4,
            arrows: true,
            dots: false,
            prevArrow: '.carousel-arrows .carousel-prev',
            nextArrow: '.carousel-arrows .carousel-next',
            responsive: responsiveConfig
        });
    });
    // Helper: slidesToScroll by viewport (must match collection carousel responsive breakpoints)
    function collectionCarouselSlidesToScroll() {
        var w = window.innerWidth || document.documentElement.clientWidth || 0;
        if (w > 1024) return 4;
        if (w > 600) return 2;
        return 1;
    }
    // Mobile dashes for collection carousel (when "Use dashes on mobile" is enabled)
    function initCollectionCarouselDashes() {
        $('.component-collection-carousel.carousel-mobile-dashes').each(function () {
            var $section = $(this);
            var $dashesEl = $section.find('.carousel-mobile-dashes');
            var $slider = $section.find('.collection-carousel');
            if (!$dashesEl.length || !$slider.length || !$slider.hasClass('slick-initialized')) return;
            var slickInstance = $slider.slick('getSlick');
            var slideCount = slickInstance.slideCount;
            var slidesToScroll = collectionCarouselSlidesToScroll();
            if (slideCount <= 0) return;
            var pageCount = Math.ceil(slideCount / slidesToScroll);
            $dashesEl.empty();
            for (var i = 0; i < pageCount; i++) {
                var btn = $('<button type="button" class="carousel-mobile-dash" aria-label="Go to page ' + (i + 1) + '" data-page-index="' + i + '">');
                if (i === 0) btn.addClass('active');
                $dashesEl.append(btn);
            }
            $dashesEl.off('click.carouselDashes').on('click.carouselDashes', '.carousel-mobile-dash', function () {
                var pageIdx = parseInt($(this).data('page-index'), 10);
                var scroll = collectionCarouselSlidesToScroll();
                var slideIdx = pageIdx * scroll;
                $slider.slick('slickGoTo', slideIdx);
            });
            $slider.off('afterChange.carouselDashes').on('afterChange.carouselDashes', function (e, slick, currentSlide) {
                var scroll = collectionCarouselSlidesToScroll();
                var currentPageIndex = Math.floor(currentSlide / scroll);
                $dashesEl.find('.carousel-mobile-dash').each(function (idx) {
                    $(this).toggleClass('active', idx === currentPageIndex);
                });
            });
            $slider.off('breakpoint.carouselDashes').on('breakpoint.carouselDashes', function () {
                setTimeout(initCollectionCarouselDashes, 100);
            });
        });
    }
    initCollectionCarouselDashes();
});

// Testimonial Carousel
$(document).ready(function () {
    var collectionCarousel = $(".testimonial-carousel");
    collectionCarousel.each(function () {
        $(this).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            centerMode: true,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            centerPadding: '220px',
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: true,
                        arrows: false,
                        centerPadding: '160px'
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: true,
                        centerPadding: '0px'
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        centerMode: false,
                        centerPadding: '40px',
                        slidesToShow: 1,
                        dots: false
                    }
                }
            ]
        });
    });
});



$('.js-blog-carousel').slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 2,
            }
        },
        {
            breakpoint: 600,
            centerMode: true,
            centerPadding: '60px',
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                arrows: false,

            }
        }
    ]

});




// PDP CAROUSEL WITH THUMBS
$('.js-slider-primary').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    infinite: true,
    dots: false,
    asNavFor: '.js-slider-thumbs',
    responsive: [
        {
            breakpoint: 768,
            settings: {
                dots: true,
                dotsClass: 'slick-dots pdp-mobile-dots',
                asNavFor: null
            }
        }
    ]
});
$('.js-slider-thumbs').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.js-slider-primary',
    dots: false,
    centerMode: false,
    focusOnSelect: true,
    infinite: true,
    variableWidth: false,
    arrows: true,
    prevArrow: '.product-thumbs .carousel-prev',
    nextArrow: '.product-thumbs .carousel-next',
    responsive: [
        {
            breakpoint: 768,
            settings: 'unslick'
        }
    ]
});

// CHANGE IMAGE WITH VARIANT CHANGE
(function (window, $) {
    $(document).ready(function () {
        $('body')
            .on('change', '#productSelect', function (event) {
                // Update Price
                var selected = this.options[this.selectedIndex],
                    variantPrice = selected.dataset.price;

                $('#productPrice').text('$' + variantPrice);

                /** Update image Slider */
                var variantImage = selected.dataset.image;
                var position = -1;

                $('.product-thumbs .single-thumb').each(function () {
                    if ($(this).data('image') == variantImage) {
                        position = parseInt($(this).data('slick-index'));
                        return;
                    }
                });

                if (position != -1) {
                    $('.product-thumbs').find('.js-slider-thumbs').slick('slickGoTo', position);
                }


                /** Update Nutritions table tab content */
                if (this.options.length > 1 && window.product_variants !== undefined) {
                    product_variants.forEach((variant_meta) => {
                        if (variant_meta.id == selected.value) {
                            for (const [key, value] of Object.entries(variant_meta)) {
                                $(`.js-meta-${key}`).empty().html(value);
                            }
                        }
                    });
                }
            })
    })
})(window, jQuery);


// Footer Nav

function resizeHandler() {

    if ($(window).width() < 990) {
        $('.footer-nav ul').hide();
        $('.footer-nav ul').slideUp(200);
    } else {
        $('.footer-nav ul').show();
        $('.footer-nav-header').removeClass("expanded");
    }
}

resizeHandler();

$(document).ready(resizeHandler);

$('body').on('click', '.footer-nav-header', function () {
    if ($(window).width() < 990) {
        $(this).next().slideToggle(200);
        $(this).toggleClass("expanded");
    }
});

// Recipe Carousel
$(document).ready(function () {
    var recipeCarousel = $(".js-featured-recipe-carousel");
    recipeCarousel.each(function () {
        $(this).slick({
            slidesToShow: 4,
            slidesToScroll: 4,
            arrows: true,
            dots: false,
            prevArrow: '.carousel-arrows .carousel-prev',
            nextArrow: '.carousel-arrows .carousel-next',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        arrows: true,
                    }
                },
                {
                    breakpoint: 600,
                    centerMode: true,
                    centerPadding: '60px',
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: false,
                        arrows: true,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        centerMode: true,
                        centerPadding: '40px',
                        slidesToShow: 1,
                        arrows: true,
                        dots: false,
                    }
                }
            ]
        });
    });
});

// Klaviyo Accessibility Fix
window.addEventListener('klaviyoForms', function (e) {
    if (e.detail.type == 'embedOpen') {
        setTimeout(function () {
            const element = document.querySelector('.kl-private-reset-css-Xuajs1');
            if (element) {
                element.setAttribute('aria-modal', 'true');
                element.setAttribute('aria-label', 'Email Popup');
                element.setAttribute('role', 'dialog');
                element.removeAttribute('aria-describedby');
            }
            const emailField = {
                footer: document.getElementById('email_91029883'),
                blog: document.getElementById('email_34777718')
            }
            if (emailField.footer) {
                emailField.footer.setAttribute('aria-required', 'true');
            }
            if (emailField.blog) {
                emailField.blog.setAttribute('aria-required', 'true');
            }
        }, 500);
    }
});


/* Product Card Fully Clickable */
document.addEventListener('click', function(event) {
    const textWrapper = event.target.closest('.text-wrapper');
    const addToCart = event.target.closest('form[action="/cart/add"]');

    if (textWrapper && !addToCart) {
        const url = textWrapper.getAttribute('data-url');
        if (url) {
            window.location.href = url;
        }
    }
});

/* Product Card Reviews on Mobile */
function formatYotpoReviewsMobile() {
    const isMobile = () => window.innerWidth <= 480;

    function updateReviewText() {
        if (!isMobile()) return;

        const elements = document.querySelectorAll('.product-grid-col .yotpo-sr-bottom-line-text');

        elements.forEach((el) => {
            const originalText = el.innerText.trim();

            if (!el.classList.contains('mobile-active') && /(\d+)\s+Reviews/.test(originalText)) {
                const match = originalText.match(/(\d+)\s+Reviews/);
                if (match) {
                    el.innerText = `[${match[1]}]`;
                    el.classList.add('mobile-active');
                }
            }
        });
    }

    function waitForYotpoAndUpdate() {
        const interval = setInterval(() => {
            const elements = document.querySelectorAll('.product-grid-col .yotpo-sr-bottom-line-text');
            const ready = elements.length && Array.from(elements).some(el => /\d+\s+Reviews/.test(el.innerText));
            if (ready) {
                clearInterval(interval);
                updateReviewText();

                // Additional re-checks to override Yotpo re-render
                setTimeout(updateReviewText, 1000);
                setTimeout(updateReviewText, 2000);
                setTimeout(updateReviewText, 3000);
            }
        }, 200);

        // Stop waiting after 5 seconds
        setTimeout(() => clearInterval(interval), 5000);
    }

    if (isMobile()) waitForYotpoAndUpdate();

    window.addEventListener('resize', () => {
        if (isMobile()) waitForYotpoAndUpdate();
    });
}

document.addEventListener('DOMContentLoaded', function () {
    formatYotpoReviewsMobile();
});

// Open Klaviyo Sold Out Form
document.addEventListener('DOMContentLoaded', function() {
    function getQueryParam(param) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(param);
    }

    if (getQueryParam('oos') === '1') {
        let intervalCounter = 0;
        const maxIntervalChecks = 20;
        const checkInterval = 1000;

        const intervalId = setInterval(function() {
            const targetElement = document.getElementById('BIS_trigger');

            if (targetElement) {
                setTimeout(function(){
                    targetElement.click();
                }, 1600);
                clearInterval(intervalId);

            }
            intervalCounter++;

            if (intervalCounter >= maxIntervalChecks) {
                clearInterval(intervalId);
            }
        }, checkInterval);
    }
});
// Supports one or multiple accordions on the page
document.querySelectorAll("[data-accordion]").forEach((acc) => {
    const trigger = acc.querySelector(".accordion__trigger");
    const panel = acc.querySelector(".accordion__panel");

    // Ensure starting state
    panel.hidden = true;
    panel.style.maxHeight = "0px";
    trigger.setAttribute("aria-expanded", "false");

    const open = () => {
        panel.hidden = false;
        panel.classList.add("is-open");
        // First set to 0 to ensure transition runs, then to scrollHeight
        panel.style.maxHeight = "0px";
        requestAnimationFrame(() => {
            panel.style.maxHeight = panel.scrollHeight + "px";
        });
        trigger.setAttribute("aria-expanded", "true");
    };

    const close = () => {
        // Set to current height to start transition down
        panel.style.maxHeight = panel.scrollHeight + "px";
        requestAnimationFrame(() => {
            panel.style.maxHeight = "0px";
        });
        trigger.setAttribute("aria-expanded", "false");
        panel.addEventListener(
            "transitionend",
            (e) => {
                if (e.propertyName === "max-height") {
                    panel.hidden = true;
                    panel.classList.remove("is-open");
                }
            },
            { once: true }
        );
    };

    trigger.addEventListener("click", () => {
        const expanded = trigger.getAttribute("aria-expanded") === "true";
        expanded ? close() : open();
    });
});
